export const GlobalDtFormat = 'YYYY.DD.MM HH:mm';